export default __webpack_public_path__ + "static/media/Armwraps of the Darkwretch.093be3d8.jpg";